var map = {
	"./TCL_Logo_langgezogen.svg": 1480,
	"./TCL_Logo_versetzt.svg": 5084,
	"./top-creators-2024-back.svg": 9231,
	"./top-creators-2024-ig-like-etc-desktop.svg": 8456,
	"./top-creators-2024-ig-like-etc-mobile.svg": 2982,
	"./top-creators-2024-ig-save-desktop.svg": 4459,
	"./top-creators-2024-ig-save-mobile.svg": 3855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2237;